<template>
  <section class="TcTest container mx-auto p-5">
    <h2 class="text-center">TcTest</h2>
    <div v-text="token"></div>
    <div v-text="create_ticket_url"></div>
    <input v-model="event_id">
    <button @click="postEvent">Crear</button>
    <pre class="text-xs">{{ JSON.stringify($root.user, null, 2) }}</pre>
    <pre class="text-xs">{{ JSON.stringify(out, null, 2) }}</pre>
    <div class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <TcInscriptionConfirm
          v-if="true"
          :event="event"
          :guests="guests"
          :children="children"
          :companions="companions"
        ></TcInscriptionConfirm>
        <TcInscriptionSuccess v-if="false"></TcInscriptionSuccess>
        <TcInscriptionError v-if="false"></TcInscriptionError>
      </div>
    </div>
  </section>
</template>

<script>
import TcInscriptionConfirm from './TcInscriptionConfirm.vue'
import TcInscriptionSuccess from './TcInscriptionSuccess.vue'
import TcInscriptionError from './TcInscriptionError.vue'
export default {
  name: 'TcTest',
  components: {
    TcInscriptionConfirm,
    TcInscriptionSuccess,
    TcInscriptionError,
  },
  props: [],
  data () {
    return {
      token: '',
      create_ticket_url: '',
      event_id: '96',
      error_msg: 'No se ha podido conectar con el serivor. Contacte con administración.',
      event: {price: 50},
      //guests: {amount: 2, unit_price: 50.0},
      //children: {amount: 1, unit_price: 10.0},
      //companions: {amount: 3, unit_price: 50.0},
      guests: null,
      children: null,
      companions: null,
    }
  },
  computed: {
    tickets: function() { return [
        {
          "user_id" : this.$root.user ? this.$root.user.id.toString() : '',
          "event_id" : this.event_id,
          "member_number" : this.$root.user ? this.$root.user.number.toString() : '',
          "member_address" : "Calle Uría 33- 6º derecha",
          "member_town" : "Oviedo",
          "member_postal_code" : "33003",
          "total_companions" : "1",
          "total_guests" : "1",
          "total_guests_children" : "1",
          "request_bus" : "1",
          "observations" : "Ninguna observación",
          "allergies" : "Ninguna alergia",
          "payer" : "1",
          "society_id" : "",
          "member_name" : this.$root.user ? this.$root.user.user.name : '',
          "member_first_surname" : this.$root.user ? this.$root.user.user.surname1 : '',
          "member_second_surname" : this.$root.user ? this.$root.user.user.surname2 : '',
          "member_nif" : this.$root.user_profile ? this.$root.user_profile.nif : '',
          "guests": {"1":{"name":"Invitado1","nif":"74066018S"},"2":{"name":"Invitado2","nif":"74066018S"}},
          "guests_children": {"1":{"name":"Ni\u00f1o1","nif":""},"2":{"name":"Ni\u00f1o2","nif":""}},
          "companions": {"1":{"name":"Acompa\u00f1ante1","nif":"123456"},"2":{"name":"Acompa\u00f1ante2","nif":"678912A"}}
        }
      ]
    },
    out: function() {
      return {
        access_token: this.$root.access_token,
        tickets: this.tickets,
      }
    },
  },
  methods: {
    postEvent: function() {
      console.log('postEvent POSTING', this.out);
      //var body = {
      //  access_token: this.$root.access_token,
      //  action: 'create_ticket',
      //  params: this.out,
      //}
      var body = {
          action: 'create_ticket',
          access_token: this.$root.access_token,
          params: {
            access_token: this.$root.access_token,
            tickets: this.tickets,
          }
      }
      console.log('BODY', body)
      fetch('/post.php',{
        method: 'POST',
        body : JSON.stringify(body),
      }).then(response => response.json())
      .then(json => {
        console.log('postEvent JSON', json)
      })
      .catch(error => {
        console.error('ERROR EN TcTest', error)
      })
    },
  },
  mounted() {
    this.token = this.$root.access_token
    this.create_ticket_url = this.$root.create_ticket_url()
    this.user = this.$root.user
  }
}
</script>